/* eslint-disable react/no-unstable-nested-components */
import { useContext } from 'react';

// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Skeleton from 'react-loading-skeleton';
import { LoadingContext } from 'context/loadingContext';
import Header from 'components/molecules/Header';

import topNavData from 'nav.json';
// import { AuthContext } from 'context/authContext';
import { useParams } from 'react-router-dom';
import logoImg from 'assets/images/veon-logo.svg';
import logoImgBlack from 'assets/images/veon-logo.svg';
import UserActions from 'components/organisms/UserActions';
import Heading from 'components/atoms/Heading';
import Button from 'components/atoms/Button';
import NotificationBox from 'components/organisms/NotificationBox';
import { LogoHolder, HeaderWrap, RightCol, SearchHolder } from './TopBar.styles';

function TopBar() {
  const { isLoading } = useContext(LoadingContext);
  // eslint-disable-next-line prefer-const
  let { view: title, child } = useParams();
  const data = topNavData.find(({ file }) => file === title);
  if (data && data !== '') {
    title = data.name;
    if (child && data.subNav && data.subNav.length > 0) {
      const res = data.subNav.find(({ file }) => file === child);
      title = res?.name;
    }
  }

  return (
    <Header title={title?.split('-')?.join(' ')}>
      {isLoading ? (
        <Skeleton rectangle height={40} width={131} css="border-radius:8px !important;" />
      ) : (
        <>
          <LogoHolder>
            <img className="logoWhite" src={logoImg} width="82" height="32" alt="Veonpay" />
            <img className="logoBlack" src={logoImgBlack} width="108" alt="Veonpay" />
          </LogoHolder>
          <HeaderWrap>
            <Heading level={1}>{title?.split('-')?.join(' ')}</Heading>
            <RightCol>
              <SearchHolder>
                <Button type="submit">
                  <span className="icon-search" />
                </Button>
              </SearchHolder>
              <NotificationBox />
              <UserActions />
            </RightCol>
          </HeaderWrap>
        </>
      )}
    </Header>
  );
}

export default TopBar;
